"use client";

import { Toaster } from "@oreme/ui";
import { Provider as StoreProvider } from "jotai";
import { NextIntlClientProvider as IntlProvider } from "next-intl";
import { ThemeProvider } from "next-themes";
import React, { PropsWithChildren } from "react";
import { createGlobalStore } from "@/store/global";
import { User } from "@/types";

interface GlobalProviderProps extends PropsWithChildren {
  user: User | null;
  locale: string;
  messages?: Record<string, undefined>;
}

function GlobalProvider({
  children,
  user,
  locale,
  messages,
}: Readonly<GlobalProviderProps>) {
  const store = createGlobalStore(user);
  return (
    <StoreProvider store={store}>
      <ThemeProvider
        attribute="class"
        defaultTheme="light"
        enableSystem
        disableTransitionOnChange
      >
        <IntlProvider
          locale={locale}
          messages={messages}
          timeZone="Europe/Paris"
        >
          {children}
        </IntlProvider>
      </ThemeProvider>
      <Toaster />
    </StoreProvider>
  );
}

export { GlobalProvider, type GlobalProviderProps };
